import { ReactNode, FC } from 'react';
import { Text } from '@dodilio/ui-design-lib';
import { HeroShell } from '../../components/HeroShell';
import { useReferral } from '../../useReferral';

interface CreateAccountLayoutProps {
    children: ReactNode;
}

// The first card a partner's link lands on: say the link worked, before
// anything is asked. The check is the same one the org step uses, and its
// answer is kept for it.
const CreateAccountPane = () => {
    const referral = useReferral();
    return (
    <>

        <h1
            style={{
                fontSize: 'clamp(22px, 2.6vw, 28px)',
                fontWeight: 300,
                lineHeight: 1.05,
                letterSpacing: '-0.03em',
                margin: '0 0 18px',
                color: 'var(--gray-12)',
            }}
        >
            Build AI-powered systems.
            <br />
            <span
                style={{
                    color: 'var(--gray-11)',
                    fontWeight: 300,
                    fontSize: '0.78em',
                }}
            >
                No card needed.
            </span>
        </h1>

        <Text
            as="p"
            size="2"
            className="heroPaneDesc"
            style={{ color: 'var(--gray-11)', margin: '0 0 24px', lineHeight: 1.5 }}
        >
            Your workspace in seconds. Pay only when you scale past the free tier.
        </Text>

        {referral.check?.kind === 'valid' && (
            <Text as="p" size="2" style={{ color: 'var(--gray-11)', margin: '0 0 24px' }}>
                {referral.check.partnerDisplayName
                    ? <>Referred by <Text weight="medium" style={{ color: 'var(--gray-12)' }}>{referral.check.partnerDisplayName}</Text></>
                    : 'Referred by a Dodil partner'}
            </Text>
        )}
    </>
    );
};

export const CreateAccountLayout: FC<CreateAccountLayoutProps> = ({ children }) => {
    return (
        <HeroShell title="Create an account" leftPane={<CreateAccountPane />}>
            {children}
        </HeroShell>
    );
};
